<template>
    <svg
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width="60"
        height="60">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.6094 8.46535C22.6094 6.55149 24.1609 5 26.0747 5H33.9248C35.8386 5 37.3901 6.55149 37.3901 8.46535V36.6124L37.3919 36.6124C37.3919 38.3451 37.0291 42.3296 36.2957 45.9123C35.7473 48.5911 34.5423 52.2723 33.9502 54.0124C33.7479 54.6071 33.1888 55 32.5607 55L30.0339 55H29.9661L27.4393 55C26.8112 55 26.2521 54.6071 26.0498 54.0124C25.4577 52.2723 24.2527 48.5911 23.7043 45.9123C22.9709 42.3296 22.6081 38.3451 22.6081 36.6124L22.6094 36.6124V8.46535Z"
            fill="white"
            fill-opacity="0.05"
            stroke="#EEEEEE" />
        <path
            d="M34.7692 12.7437C34.7692 15.3774 32.6342 17.5125 30.0005 17.5125C27.3668 17.5125 25.2317 15.3774 25.2317 12.7437C25.2317 10.11 27.3668 7.97498 30.0005 7.97498C32.6342 7.97498 34.7692 10.11 34.7692 12.7437Z"
            fill="white"
            fill-opacity="0.05"
            stroke="#EEEEEE" />
        <path
            d="M25.5874 21.8133C25.5874 20.811 26.3999 19.9985 27.4022 19.9985H32.6736C33.6759 19.9985 34.4884 20.811 34.4884 21.8133V25.0337C34.4884 26.036 33.6759 26.8485 32.6736 26.8485H27.4022C26.3999 26.8485 25.5874 26.036 25.5874 25.0337V21.8133Z"
            fill="white"
            fill-opacity="0.05"
            stroke="#EEEEEE" />
        <path
            d="M32.8752 48.1543L32.7844 48.1667H32.6921H32.4614H27.4243H27.2762H27.1936C26.5861 48.1667 26.0651 47.764 25.9247 47.1894C25.477 45.3581 24.7762 42.1045 24.7762 39.7403L24.7762 30.8498C24.7762 30.8498 24.7762 30.8498 24.7762 30.8498C24.7762 30.104 25.3807 29.5001 26.128 29.5001H27.2762H27.4243H32.4614H32.9429H33.7577C34.505 29.5001 35.1095 30.104 35.1095 30.8498L35.1095 39.7403C35.1095 42.1045 34.4087 45.3581 33.961 47.1894C33.8348 47.7057 33.4023 48.0824 32.8752 48.1543Z"
            fill="white"
            fill-opacity="0.05"
            stroke="#EEEEEE" />
        <path
            d="M28.4113 30.0718V45.2416"
            stroke="#EEEEEE" />
        <path
            d="M31.5958 30.0718V45.2416"
            stroke="#EEEEEE" />
        <path
            d="M24.8039 35.129H35.1645"
            stroke="#EEEEEE" />
        <path
            d="M24.8039 32.5111H28.4106"
            stroke="#EEEEEE" />
        <path
            d="M31.5958 32.5111H35.2026"
            stroke="#EEEEEE" />
        <path
            d="M24.8039 37.6741H35.1645"
            stroke="#EEEEEE" />
        <path
            d="M24.8039 40.2206H35.1645"
            stroke="#EEEEEE" />
        <path
            d="M24.8254 42.7619L34.9816 42.7619"
            stroke="#EEEEEE" />
        <path
            d="M25.3464 45.2364H34.461"
            stroke="#EEEEEE" />
    </svg>
</template>

<script setup lang="ts"></script>
